import { AppConfigService } from '../../app-load/services/app-config.service';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { PasswordApi } from '../api/password.api';

@Injectable()
export class PasswordService {
  private readonly apiRoutes = {
    setPassword: (): string => `${this.endPoint}/set`,
    userVerify: (): string => `${this.endPoint}/user/verify`,
    changePassword: (): string => `${this.endPoint}/change`
  };

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {}
  get endPoint(): string {
    return (
      this.appConfigService.getConfig().apiGatewayEndpoint +
      '/api/rest/v2/password'
    );
  }

  setPassword(request: PasswordApi.SetPassword.Request): Observable<void> {
    return this.http.post<void>(this.apiRoutes.setPassword(), request);
  }

  changePassword(
    request: PasswordApi.ChangePassword.Request
  ): Observable<void> {
    return this.http.post<void>(this.apiRoutes.changePassword(), request);
  }

  validateDateOfBirth(
    request: PasswordApi.UserVerify.Request
  ): Observable<PasswordApi.UserVerify.Response> {
    return this.http.post<PasswordApi.UserVerify.Response>(
      this.apiRoutes.userVerify(),
      request
    );
  }

  private getHttpOptions() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic ' + this.appConfigService.getConfig().clientSecret
      })
    };
    return httpOptions;
  }
}
